"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductBoxSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductBoxSkeleton = ({
  animation = 'pulse',
  ...props
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": getTestId(_constants.PRODUCT_BOX_SKELETON),
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BasicSkeleton, {
      animation: animation,
      height: 210
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TextSkeleton, {
      variant: "text",
      height: 19,
      width: "60%",
      animation: animation,
      marginTop: "18px"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TextSkeleton, {
      variant: "text",
      height: 19,
      width: "40%",
      animation: animation,
      marginTop: "8px"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TextSkeleton, {
      variant: "text",
      height: 25,
      width: "65px",
      animation: animation,
      marginTop: "38px"
    })]
  });
};
exports.ProductBoxSkeleton = ProductBoxSkeleton;
//# sourceMappingURL=ProductBoxSkeleton.js.map